<template>
        <div class="templete">
            <div class="search_box search_box_f clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始日期"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
                </div>
                <el-input class="search_input search_inputBox" v-model="params.contract_no" placeholder="合同号"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.bill_lading_no" placeholder="提单号"></el-input>
                <!-- <el-input class="search_input search_inputBox" v-model="params.status" placeholder="订单状态"></el-input> -->
                <el-select class="search_select search_inputBox" v-model="params.status" placeholder="订单状态">
                    <el-option :value="0" :label="'未完成'"></el-option>
                    <el-option :value="1" :label="'已完成'"></el-option>
                    <el-option :value="999" :label="'全部状态'"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.supplier_id" multiple collapse-tags placeholder="供应商" filterable @visible-change="getSelectList('supplier')">
                    <el-option v-for="list in selectMap.supplier" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.breed_id" multiple collapse-tags placeholder="树种" @visible-change="getBreed">
                    <el-option v-for="list in breedList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <div class="searchBtnList clearfix">
                    <!-- <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div> -->
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                </div>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                    <span class="excel_btn" @click="excelExport"><i class="excel-icon"></i>excel导出</span>
                </div>
            </div>
            <div class="btnList clearfix">
                <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="module.indexOf(',purchase-order-add-cont,')!=-1" @click="isShowContract=!isShowContract;contractType=2;categoryList.length==1?contractForm.category=categoryList[0].id:''">添加合同</el-button>
                <!-- <el-button class="funcPublicBtn" v-if="module.indexOf(',purchase-order-add-fee,')!=-1" @click="addFee">添加费用</el-button> -->
                <!-- <el-button class="funcPublicBtn">捆包明细</el-button> -->
            </div>
            <div class="tableBox">
                <tabletem :isSetCol="true" scene="purchase.wood.list" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @getTableDelete="getTableDelete" @getTableSee="getTableSee" @getTableEdit="getTableEdit" @rowClick="rowClick"></tabletem>
            </div>
            <div class="totalCal">
                <div class="totalName">合计：</div>
                <div class="totalNumber">订单数量:{{totalObj.total_sum}}</div>
                <div class="totalNumber">入库数量:{{totalObj.stock_sum}}</div>
                <div class="totalNumber">在途数量{{totalObj.ship_sum}}</div>
                <div class="totalNumber">外币总金额:{{totalObj.foreign_currency_total}}</div>
                <div class="totalNumber">采购总金额{{totalObj.rmb_cost_amount}}</div>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
            <el-dialog v-dialog-drag :visible.sync="isShowContract" class="eldialog eldialogA" width="630px" :modal="false" :title="contractType==2?'添加合同':'修改合同'" custom-class="full_dialog">
                <el-form :rules="contractRules" ref="contractForm" :model="contractForm" class="clearfix">
                    <div class="eldialogFormBox">
                        <el-form-item  label="合同号：" prop="contract_no">
                            <el-input v-model="contractForm.contract_no"></el-input>
                        </el-form-item>
                        <el-form-item  label="合同日期：" prop="contract_time">
                            <el-date-picker v-model="contractForm.contract_time" type="date" placeholder="" size="mini"></el-date-picker>
                        </el-form-item>
                        <el-form-item  label="供应商：" prop="supplier_id">
                            <el-select v-model="contractForm.supplier_id"  @visible-change="getSelectList('supplier')" filterable>
                                <el-option v-for="list in selectMap.supplier" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item  label="船名：" prop="ship_no">
                            <el-input v-model="contractForm.ship_no"></el-input>
                        </el-form-item>
                        <!-- <el-form-item  label="货柜：" prop="container_no">
                            <el-input v-model="contractForm.container_no"></el-input>
                        </el-form-item> -->
                        <el-form-item  label="树种：" prop="breed_id">
                            <el-select v-model="contractForm.breed_id" @visible-change="getSelectList('breed')">
                                <el-option v-for="list in selectMap.breed" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item  label="批次号：" prop="batch_no">
                            <el-input v-model="contractForm.batch_no"></el-input>
                        </el-form-item>
                        <el-form-item  label="根数：" prop="pieces">
                            <el-input v-model="contractForm.pieces"></el-input>
                        </el-form-item>
                        <el-form-item  label="堆号：" prop="heap_no">
                            <el-input v-model="contractForm.heap_no"></el-input>
                        </el-form-item>
                        <el-form-item  label="立方：" prop="cube">
                            <el-input v-model="contractForm.cube"></el-input>
                        </el-form-item>
                        <el-form-item  label="单价：" prop="cube_price">
                            <el-input v-model="contractForm.cube_price"></el-input>
                        </el-form-item>
                        <el-form-item  label="外币总金额：" class="dialogTwo clearfix" prop="foreign_currency_amount">
                            <el-select class="twoSelect" v-model="contractForm.foreign_currency_id" @visible-change="getSelectList('currency')">
                                <el-option v-for="list in selectMap.currency" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                            <el-input class="twoInput" v-model="contractForm.foreign_currency_amount"></el-input>
                        </el-form-item>
                        <el-form-item  label="采购总金额：" prop="rmb_amount">
                            <!-- title="采购总金额有两种用法:1.采购总金额可以只填入购买木材(不包含其他费用),即总金额/合同入库立方=采购单价,其他成本费用在'添加费用'里面选择对应的合同号、提单号就会平摊到'成本费用平摊单价'里。2.采购金额也可以填入购买这批材料所支付的所有费用金额(包含税金、报关等其他费用),即总金额/合同入库立方=采购成本单价(所以库存统计里面的'采购单价'根据用户选择使用方式可以是'采购单价'也可以是'采购成本单价',两种方式都能非常准确的获得采购成本及成本费用)"  -->
                            <span slot="label" class="formLabelQuestionA contractLabel" style="position:relative;">
                                <span>采购总金额：</span>
                                <div class="labelTip">
                                    <div class="labelZhu">注:</div>
                                    <div class="laCbelTipC">采购总金额有两种用法</div>
                                    <div class="laCbelTipC">1.采购总金额可以只填入购买木材(不包含其他费用),即总金额/合同入库立方=采购单价,其他成本费用在'添加费用'里面选择对应的合同号、提单号就会平摊到'成本费用平摊单价'里。</div>
                                    <div class="laCbelTipC">2.采购金额也可以填入购买这批材料所支付的所有费用金额(包含税金、报关等其他费用),即总金额/合同入库立方=采购成本单价(所以库存统计里面的'采购单价'根据用户选择使用方式可以是'采购单价'也可以是'采购成本单价',两种方式都能非常准确的获得采购成本及成本费用)</div>
                                </div>
                            </span>
                            <el-input v-model="contractForm.rmb_amount" placeholder="RMB"></el-input>
                        </el-form-item>
                        <el-form-item  label="预付定金时间：" prop="expected_pay_time">
                            <el-date-picker v-model="contractForm.expected_pay_time" type="date" placeholder="" size="mini"></el-date-picker>
                        </el-form-item>
                        <el-form-item  label="付余款时间：" prop="payment_time">
                            <el-date-picker v-model="contractForm.payment_time" type="date" placeholder="" size="mini"></el-date-picker>
                        </el-form-item>
                        <el-form-item  label="预计收到提单时间：" prop="expected_arrival_time">
                            <el-date-picker v-model="contractForm.expected_arrival_time" type="date" placeholder="" size="mini"></el-date-picker>
                        </el-form-item>
                        <!-- <el-form-item  label="RMB总金额：" prop="rmb_amount">
                            <el-input v-model="contractForm.rmb_amount"></el-input>
                        </el-form-item> -->
                        <el-form-item  label="付款方：" prop="payer">
                            <!-- <el-input v-model="contractForm.payer"></el-input> -->
                            <el-select v-model="contractForm.payer" @visible-change="getSelectList('payerList')">
                                <el-option v-for="(list,index) in selectMap.payerList" :key="index" :value="list.id+'_'+list.type" :label="list.type_text+':'+list.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item  label="订单状态：" prop="status" v-if="contractForm.id">
                            <el-select v-model="contractForm.status">
                                <el-option :value="1" label="已完成"></el-option>
                                <el-option :value="0" label="未完成"></el-option>
                            </el-select>
                        </el-form-item>
                        <!-- <el-form-item  label="备注：" prop="remark">
                            <el-input v-model="contractForm.remark"></el-input>
                        </el-form-item> -->
                        <el-form-item  label="备注：" prop="remark" class="remarks">
                            <el-input v-model="contractForm.remark"></el-input>
                            <div class="remarksBtnBox clearfix" v-if="contractForm.remarks.length<=0">
                                <img src="../../assets/plus-hover@2x.png" class="remarks_add" @click="remarksAdd"/>
                            </div>
                        </el-form-item>
                        <el-form-item class="remarks" label="备注：" v-for="(remark,index) in contractForm.remarks" :key="'_'+index">
                            <el-input v-model="contractForm.remarks[index].remark"></el-input>
                            <div class="remarksBtnBox clearfix">
                                <img src="../../assets/plus-hover@2x.png" v-if="contractForm.remarks.length-1==index" class="remarks_add" @click="remarksAdd"/>
                                <img src="../../assets/top-delete-suspension.png" class="remarks_remove" @click="remarksRemove(index)"/>
                            </div>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="dialogBtnList clearfix">
                    <el-button  class="publicBtn dialogBtn" v-if="contractType==2" @click="addContract(2)">保存并新增</el-button>
                    <el-button  class="funcPublicBtn dialogBtn" v-if="contractType==2" @click="addContract(1)">保存</el-button>
                    <el-button  class="publicBtn dialogBtn" v-if="contractType==3" @click="addContract">确定</el-button>
                    <!-- <el-button class="dialogBtn funcPublicBtn" v-if="contractType==3" @click="isShowContract=!isShowContract">关闭</el-button> -->
                </div>
            </el-dialog>
            <el-dialog v-dialog-drag :visible.sync="isShowCost" class="eldialog eldialogLine" :modal="false" title="添加成本费用" custom-class="full_dialog">
                <div class="dialogSearchBox">
                    <el-form :model="feeForm" class="clearfix dialogFormB">
                        <el-form-item  label="日期：" prop="realname">
                            <el-date-picker v-model="feeForm.fee_date" type="date" placeholder="" size="mini"></el-date-picker>
                        </el-form-item>
                        <el-form-item  label="合同号：" prop="contract_no">
                            <el-input v-model="feeForm.contract_no" readonly></el-input>
                        </el-form-item>
                        <el-form-item  label="提单号：" prop="bill_lading_no">
                            <el-select v-model="feeForm.bill_lading_no" clearable @visible-change="feeChange('bill_lading_no')">
                                <el-option v-for="(list,index) in bill_lading_no_list" :key="index" :value="list" :label="list"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item  label="货柜号：" prop="container_no">
                            <el-select v-model="feeForm.container_no" clearable @visible-change="feeChange('container_no')">
                                <el-option v-for="(list,index) in container_no_list" :key="index" :value="list" :label="list"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item  label="费用名称：" prop="fee_id">
                            <el-select v-model="feeForm.fee_id"  @visible-change="getSelectList('purchaseCost')" clearable>
                                <el-option v-for="list in selectMap.purchaseCost" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item  label="收款人(单位)：" prop="payee">
                            <el-input v-model="feeForm.payee"></el-input>
                        </el-form-item>
                        <el-form-item  label="金额(￥)：" prop="amount">
                            <el-input v-model="feeForm.amount"></el-input>
                        </el-form-item>
                        <el-form-item  label="提供发票：" prop="is_invoice">
                            <el-select v-model="feeForm.is_invoice">
                                <el-option value="1" label="是"></el-option>
                                <el-option value="0" label="否"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item  label="备注：" prop="remark">
                            <el-input v-model="feeForm.remark"></el-input>
                        </el-form-item>
                        <!-- <div class="elFormBox">
                        </div>
                        <div class="elFormBox">
                        </div>
                        <div class="elFormBox">
                        </div> -->
                        <div class="elFormBoxBtnListCol">
                            <el-button class="funcPublicBtn funcPublicBtnChecked" @click="saveFee">添加保存</el-button>
                        </div>
                    </el-form>
                </div>
            </el-dialog>
            <el-dialog v-dialog-drag :visible.sync="seeRemarksFlag" class="eldialog eldialogA" width="500px" :modal="false" title="其它备注" custom-class="full_dialog">
                <div class="remarksBox">
                    <div class="remarksText" v-show="seeRemarks.length>0" v-for="(item,index) in seeRemarks" :key="index">{{(index+1)+'、'+item.remark}}</div>
                    <div class="remarksText" v-show="seeRemarks.length<=0" style="text-align:center">无</div>
                </div>
            </el-dialog>
            <!-- 字段过滤 START -->
            <filter-fields :tableData="filter" scene="purchase.wood.list" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
            <!-- 字段过滤 END -->
        </div>
</template>
<style scoped>
    .elFormBoxBtnList .funcPublicBtnChecked{margin-left:50px;}
    .labelTip{display: none;position: absolute;bottom:20px;left:-150px;z-index:1;width:400px;text-align: left;background-color: #fff;border-radius: 4px;padding:10px;box-sizing: border-box;box-shadow: 1px 1px 5px #ccc;padding-left:30px;}
    .laCbelTipC{color:#606266;font-size: 12px;}
    .labelZhu{font-size: 12px;color:#b21111;position: absolute;top:10px;left:10px;}
    .contractLabel:hover{cursor: pointer;}
    .contractLabel:hover .labelTip{display: block;}
    .remarksText{text-align: left;padding:5px 10px;}
</style>
<script>
    import tabletem from '../../components/table.vue'
    import pagination from '../../components/pagination.vue'
    export default {
        data(){
            return{
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                // actual_arrival_time:"",
                // payment_time:"",
                // receipt_invoice:"",
                // contract_time:"",
                // expected_arrival_time:"",
                // expected_shipping_time:"",
                categoryRawType:localStorage.dw_erp_category.indexOf("raw")!=-1?true:false,
                categoryBoardType:localStorage.dw_erp_category.indexOf("board")!=-1?true:false,
                isShowMore:false,
                start_time:"",
                end_time:new Date(),
                payment_time:"",
                costTable:[
                    {date:""}
                ],
                contractType:2,//2新增 3修改
                isShowContract:false,
                isShowCost:false,
                feeList:[],
                feeForm:{
                    fee_date:"",
                    purchase_id:"",
                    contract_no:"",
                    container_no :"",
                    bill_lading_no:"",
                    fee_id:"",
                    payee:"",
                    amount:"",
                    is_invoice:"",
                    remark:""
                },
                feeFormRules:{
                    fee_date:[ { required: true, message: '请填写日期', trigger: 'blur' }],
                    purchase_id:[ { required: true, message: '请填写采购合同', trigger: 'blur' }],
                    contract_no:[ { required: true, message: '请填写合同号', trigger: 'blur' }],
                    bill_lading_no:[ { required: true, message: '请填写提单号', trigger: 'blur' }],
                    fee_id:[ { required: true, message: '请填写费用名称', trigger: 'blur' }],
                    payee:[ { required: true, message: '请填写收款单位(人)', trigger: 'blur' }],
                    amount:[ { required: true, message: '请填写金额', trigger: 'blur' }],
                    is_invoice:[ { required: true, message: '是否提供发票', trigger: 'blur' }]
                },
                contractForm:{
                    id:"",
                    contract_no:"",
                    contract_time:"",
                    supplier_id:"",
                    ship_no:"",
                    breed_id:"",
                    batch_no:"",
                    pieces:"",
                    heap_no:"",
                    cube:"",
                    cube_price:"",
                    foreign_currency_id:"",
                    foreign_currency_amount:"",
                    rmb_amount:"",
                    expected_pay_time:"",
                    payment_time:"",
                    expected_arrival_time:"",
                    payer:"",
                    remark:"",
                    remarks:[]
                },
                contractRules: {
                    contract_no:[ { required: true, message: '请填写合同号', trigger: 'blur' }],
                    contract_time:[ { required: true, message: '请填写合同日期', trigger: 'blur' }],
                    ship_no:[ { required: true, message: '请填写船名', trigger: 'blur' }],
                    pieces:[ { required: true, message: '请填写根数', trigger: 'blur' }],
                    // expected_arrival_time:[ { required: true, message: '请填写预计到港时间', trigger: 'blur' }],
                    // expected_shipping_time:[ { required: true, message: '请填写预计发货时间', trigger: 'blur' }],
                    // port_id:[ { required: true, message: '请填写目的港', trigger: 'blur' }],
                    breed_id:[ { required: true, message: '请填写树种', trigger: 'blur' }],
                    batch_no:[ { required: true, message: '请填写批次号', trigger: 'blur' }],
                    length:[ { required: true, message: '请填写长度', trigger: 'blur' }],
                    foreign_currency_id:[ { required: true, message: '请填写外币类型', trigger: 'blur' }],
                    // foreign_currency_amount:[ { required: true, message: '请填写外币金额', trigger: 'blur' }],
                    // cube:[ { required: true, message: '请填写立方', trigger: 'blur' }],
                    // rmb_amount:[ { required: true, message: '请填写人民币金额', trigger: 'blur' }],
                    // payer:[ { required: true, message: '请填写付款方', trigger: 'blur' }],
                    // category:[ { required: true, message: '请填写分类', trigger: 'blur' }]
                },
                params:{
                    start_time:"",
                    end_time:"",
                    status:0,
                    contract_no:"",
                    supplier_id:[],
                    bill_lading_no:"",
                    breed_id:"",
                    page:1,
                    per_page:50
                },
                last_page:1,
                total:0,
                selectRow:[],
                categoryList:[],
                selectMap:{
                    supplier:[],
                    breed:[],
                    brand:[],
                    creater:[],
                    grade:[],
                    port:[],
                    purchaseCost:[],
                    currency:[],
                    payerList:[],
                },
                list:[],
                tableCol:[
                    {colName:"状态",colKey:"status_text",colWidth:60,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"合同号",colKey:"contract_no",colWidth:110,isSetWidth:true,isCanClick:true,isShow:true},
                    {colName:"合同日期",colKey:"contract_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"提单号",colKey:"bill_lading_no",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"供应商",colKey:"supplier",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"品牌",colKey:"brand",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"船名",colKey:"ship_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"批次号",colKey:"batch_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"堆号",colKey:"heap_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"树种",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"片数",colKey:"pieces",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"根数",colKey:"pieces",colWidth:60,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"订单数量",colKey:"order_number",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"在途数量",colKey:"transit_number",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"入库数量",colKey:"storage_number",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"单价",colKey:"tax",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"外币总金额",colKey:"foreign_currency_amount",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"采购总金额",colKey:"rmb_amount",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"采购成本总金额",colKey:"rmb_cost_amount",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"预付定金时间",colKey:"expected_pay_time",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"预计收到提单时间",colKey:"expected_arrival_time",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"付余款时间",colKey:"payment_time",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"付款方",colKey:"payer",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"制单人",colKey:"creator_name",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:true,isShow:true,isHideShowClickImg:true,isHideCanClickColor:true}
                ],
                totalObj:{},
                bill_lading_no_list:[],
                container_no_list:[],
                filterDialogVisible:false,
                filter:"",
                fields:"",
                breedList:[],
                seeRemarks:[],
                seeRemarksFlag:false
            }
        },
        created(){
            this.getSelectList("supplier")
            this.getSelectList("breed")
            this.getSelectList("payerList")
            // this.getSelectList("creater")
            // this.getSelectList("grade")
            // this.getSelectList("port")
            // this.getSelectList("purchaseCost")
            this.getSelectList("currency")
            this.postFunc("/erp/purchase.category",{},res=>{
                this.categoryList=res.data.data;
                if(res.data.data.length==1){
                    this.contractForm.category=res.data.data[0].id
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList()
            // this.getBreed()
        },
        methods:{
            remarksAdd(){
                this.contractForm.remarks.push({remark:""})
            },
            remarksRemove(index){
                this.contractForm.remarks.forEach((item,ind)=>{
                    if(index==ind){
                        this.contractForm.remarks.splice(ind,1)
                    }
                })
            },
            getBreed(){
                this.postFunc("/erp/processing.wood.breed",{processing_id:this.processing_id},res=>{
                    this.breedList = res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            filterConfirm(){
                this.getList()
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            excelExport(){
                this.$exportExecl("/erp/purchase.wood.export","原木采购合同",this.params)
                // this.execlExportFile("/erp/purchase.export").then( (response) => {
				// 	const content = response.data;
				// 	const blob = new Blob([content], {type: response.headers['content-type']});
				// 	const fileName = this.downloadName+'.xlsx';
				// 	if ('download' in document.createElement('a')) { // 非IE下载
				// 		const elink = document.createElement('a');
				// 		elink.download = "采购订单";
				// 		elink.style.display = 'none';
				// 		elink.href = URL.createObjectURL(blob);
				// 		document.body.appendChild(elink);
				// 		elink.click();
				// 		URL.revokeObjectURL(elink.href); // 释放URL 对象
				// 		document.body.removeChild(elink);
				// 	} else { // IE10+下载
				// 		navigator.msSaveBlob(blob, fileName);
				// 	}
				// })
            },
            feeDelete(id){
                this.$confirm('是否删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
                    this.postFunc("/erp/purchase.cost.delete",{id:id},()=>{
                        this.tip('删除成功','success');
                        //this.getFeeList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            addFee(){
                if(this.selectRow.length>1||this.selectRow.length<1){
                    this.tip("请选择一条合同","warning")
                }else{
                    this.isShowCost=!this.isShowCost;
                    this.feeForm.fee_date=new Date();
                    this.feeForm.contract_no=this.selectRow[0].contract_no;
                    // this.getFeeDownMess(this.feeForm.contract_no,"bill_lading_no",this.selectRow[0].id,this.feeForm.bill_lading_no,this.feeForm.container_no)
                    // this.getFeeDownMess(this.feeForm.contract_no,"container_no",this.selectRow[0].id)
                    //this.getFeeList();
                }
            },
            feeChange(target){
                this.getFeeDownMess(this.feeForm.contract_no,target,this.selectRow[0].id,this.feeForm.bill_lading_no,this.feeForm.container_no)
            },
            getFeeDownMess(contract_no,target,purchase_id,bill_lading_no,container_no){
                this.postFunc("/erp/purchase.search.select",{contract_no:contract_no,target:target,purchase_id:purchase_id,bill_lading_no:bill_lading_no,container_no:container_no},res=>{
                    if(target=="bill_lading_no"){
                        this.bill_lading_no_list=res.data.data.result;
                    }else{
                        this.container_no_list=res.data.data.result;
                    }
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getFeeList(){
                this.postFunc("/erp/purchase.cost.list",{purchase_id:this.selectRow[0].id},res=>{
                    this.feeList=res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            saveFee(){
                this.feeForm.purchase_id=this.selectRow[0].id;
                let time = this.feeForm.fee_date;
                this.feeForm.fee_date=this.formatTimeZero(this.feeForm.fee_date);
                this.postFuncLoading("/erp/purchase.cost.create",this.feeForm,()=>{
                    this.isShowCost=!this.isShowCost;
                    this.tip("添加成功","success")
                    this.getList();
                    //this.getFeeList()
                },error=>{
                    this.feeForm.fee_date = time;
                    this.tip(error.data.message,"warning")
                })
            },
            reset(){
                this.params=this.resetSearch(this.params)
                this.start_time="";
                this.end_time=new Date();
                this.payment_time="";
                this.params.status=0;
                this.getList();
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.start_time=this.formatTimeZero(this.start_time)
                this.params.end_time=this.formatTimeZero(this.end_time)
                this.params.payment_time=this.formatTimeZero(this.payment_time)
                this.tableLoading = true;
                this.$postColumnList("/erp/purchase.wood.list",this.params,res=>{
                    this.last_page=parseInt(res.data.data.list.last_page);
                    // this.params.page=parseInt(res.data.data.list.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.list.total);
                    this.totalObj=res.data.data.total;
                    this.list=res.data.data.list.data;
                    this.list.forEach((item,index)=>{
                        if(item.contract_time!=0){
                            this.list[index].contract_time = this.formatTime(item.contract_time+"000")
                        }else{
                            this.list[index].contract_time = ""
                        }
                        if(item.payment_time!=0){
                            this.list[index].payment_time = this.formatTime(item.payment_time+"000")
                        }else{
                            this.list[index].payment_time = ""
                        }
                        if(item.expected_arrival_time!=0){
                            this.list[index].expected_arrival_time = this.formatTime(item.expected_arrival_time+"000")
                        }else{
                            this.list[index].expected_arrival_time = ""
                        }
                        if(item.actual_arrival_time!=0){
                            this.list[index].actual_arrival_time = this.formatTime(item.actual_arrival_time+"000")
                        }else{
                            this.list[index].actual_arrival_time = ""
                        }
                        if(item.receipt_invoice!=0){
                            this.list[index].receipt_invoice = this.formatTime(item.receipt_invoice+"000")
                        }else{
                            this.list[index].receipt_invoice = ""
                        }
                        if(item.expected_shipping_time!=0){
                            this.list[index].expected_shipping_time = this.formatTime(item.expected_shipping_time+"000")
                        }else{
                            this.list[index].expected_shipping_time = ""
                        }
                        if(item.expected_pay_time!=0){
                            this.list[index].expected_pay_time = this.formatTime(item.expected_pay_time+"000")
                        }else{
                            this.list[index].expected_pay_time = ""
                        }
                        // this.list[index].thickness = this.keepLimit(item.thickness)
                        // this.list[index].length = this.keepLimit(item.length)
                        item.isEdit=true;
                        item.isDelete=true;
                        this.filter = res.data.data.column;
                        this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                        this.tableCol.forEach(item=>{
                            if(this.fields.indexOf(","+item.colKey+",")!=-1){
                                item.isShow=true;
                            }else{
                                item.isShow=false;
                            }
                            if(item.colKey=="status_text"){
                                if(this.fields.indexOf(",status,")!=-1){
                                    item.isShow=true;
                                }
                            }
                        })
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            addContract(type){
                this.$refs["contractForm"].validate((valid) => {
                    if (valid) {
                        let contract_time = this.contractForm.contract_time;
                        let expected_arrival_time = this.contractForm.expected_arrival_time;
                        let expected_pay_time = this.contractForm.expected_pay_time;
                        // let actual_arrival_time = this.contractForm.actual_arrival_time;
                        let payment_time = this.contractForm.payment_time;
                        // let receipt_invoice = this.contractForm.receipt_invoice;
                        let contract_no = this.contractForm.contract_no;
                        let supplier_id = this.contractForm.supplier_id;
                        // let port_id = this.contractForm.port_id;
                        let batch_no = this.contractForm.batch_no;
                        let ship_no = this.contractForm.ship_no;
                        this.contractForm.expected_pay_time=this.formatTimeZero(this.contractForm.expected_pay_time);
                        this.contractForm.payment_time=this.formatTimeZero(this.contractForm.payment_time);
                        this.contractForm.contract_time=this.formatTimeZero(this.contractForm.contract_time);
                        this.contractForm.expected_arrival_time=this.formatTimeZero(this.contractForm.expected_arrival_time);
                        var str = this.contractForm.payer;
                        this.contractForm.payer_id = str.substring(0, str.indexOf("_"));
                        var index=str.lastIndexOf("\_");
                        this.contractForm.payer_type=str.substring(index+1,str.length);
                        // this.contractForm.receipt_invoice=this.formatTimeZero(this.contractForm.receipt_invoice);
                        // this.contractForm.expected_shipping_time=this.formatTimeZero(this.contractForm.expected_shipping_time);
                        if(this.contractType==2){
                            this.postFuncLoading("/erp/purchase.wood.create",this.contractForm,()=>{
                                if(type==2){
                                    this.contractForm=this.resetJson(this.contractForm);
                                    this.contractForm.contract_time = contract_time;
                                    this.contractForm.contract_no = contract_no;
                                    this.contractForm.supplier_id = supplier_id;
                                    this.contractForm.batch_no = batch_no;
                                    this.contractForm.ship_no = ship_no;
                                }else{
                                    this.isShowContract = false;
                                }
                                this.tip('新增成功','success');
                                this.getList();
                            },error=>{
                                this.contractForm.contract_time = contract_time;
                                this.contractForm.expected_arrival_time = expected_arrival_time;
                                this.contractForm.expected_pay_time = expected_pay_time;
                                this.contractForm.payment_time = payment_time;
                                this.tip(error.data.message,"warning")
                            },()=>{
                                this.contractForm.contract_time = contract_time;
                                this.contractForm.expected_arrival_time = expected_arrival_time;
                                this.contractForm.expected_pay_time = expected_pay_time;
                                this.contractForm.payment_time = payment_time;
                            })
                        }else{
                            this.postFuncLoading("/erp/purchase.wood.update",this.contractForm,()=>{
                                this.isShowContract = false;
                                this.tip('修改成功','success');
                                this.getList();
                            },error=>{
                                this.contractForm.contract_time = contract_time;
                                this.contractForm.expected_arrival_time = expected_arrival_time;
                                this.contractForm.expected_pay_time = expected_pay_time;
                                this.contractForm.payment_time = payment_time;
                                this.tip(error.data.message,"warning")
                            },()=>{
                                this.contractForm.contract_time = contract_time;
                                this.contractForm.expected_arrival_time = expected_arrival_time;
                                this.contractForm.expected_pay_time = expected_pay_time;
                                this.contractForm.payment_time = payment_time;
                            })
                        }
                    } else {
                        return false;
                    }
                });
            },
            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            rowClick(obj){
                if(obj.name=="contract_no"){
                    sessionStorage.removeItem("DEMU_ERP_PURCHASE_CONTRACT_ID")
                    sessionStorage.setItem("DEMU_ERP_PURCHASE_CONTRACT_ID",obj.id)
                    sessionStorage.removeItem("DEMU_ERP_PURCHASE_CONTRACT_TYPE")
                    sessionStorage.setItem("DEMU_ERP_PURCHASE_CONTRACT_TYPE",3)
                    this.$root.$children[0].$children[0].addTab({
                        name: '捆包明细'+obj.id,
                        label: '捆包明细',
                        content: 'purchaseBaleDetail'
                    });
                }else if(obj.name=="remark"){
                    this.list.forEach(item=>{
                        if(obj.id==item.id){
                            this.seeRemarks = item.remarks;
                            this.seeRemarksFlag = !this.seeRemarksFlag;
                        }
                    })
                }
            },
            getTableDelete(id){
                this.$confirm('是否删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
                    this.postFunc("/erp/purchase.delete",{id:id},()=>{
                        this.tip('删除成功','success');
                        this.getList();
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            getTableSee(id){
                this.pl(id)
            },
            getTableEdit(id){
                this.postFunc("/erp/purchase.wood.detail",{id:id},res=>{
                    this.contractType=3;
                    this.isShowContract=true;
                    this.contractForm=JSON.parse(JSON.stringify(res.data.data));
                    this.contractForm.cube=this.keepLimit(res.data.data.cube);
                    this.contractForm.contract_time=this.contractForm.contract_time*1000;
                    this.contractForm.expected_arrival_time=this.contractForm.expected_arrival_time*1000;
                    this.contractForm.expected_shipping_time=this.contractForm.expected_shipping_time*1000;
                    this.contractForm.actual_arrival_time=this.contractForm.actual_arrival_time*1000;
                    this.contractForm.payment_time=this.contractForm.payment_time*1000;
                    this.contractForm.receipt_invoice=this.contractForm.receipt_invoice*1000;
                    this.contractForm.expected_pay_time=this.contractForm.expected_pay_time*1000;
                    this.contractForm = this.clearZero(this.contractForm)
                    if(this.contractForm.remarks==""){
                        this.contractForm.remarks=[]
                    }
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getRow(row){
                this.selectRow=row;
            }
        },
        components:{
            tabletem,
            pagination
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "isShowContract":function(val){
                if(!val){
                    this.contractForm=this.resetJson(this.contractForm)
                    this.categoryList.length==1?this.contractForm.category=this.categoryList[0].id:'';
                    this.contractForm.remarks=[];
                    this.$refs.contractForm.clearValidate()
                    // this.actual_arrival_time="";
                    // this.payment_time="";
                    // this.receipt_invoice="";
                    // this.contract_time="";
                    // this.expected_arrival_time="";
                    // this.expected_shipping_time="";
                }
            },
            "isShowCost":function(val){
                if(!val){
                    this.feeForm=this.resetJson(this.feeForm)
                }
            }
        }
    }
</script>
